import { AwardJPShowElemntPIXAPP, AwardJPShowPIXAPP } from "./AwardJPShowPIXAPP";
import { ResponsiveView } from "../../../../singlegame/ResponsiveHelpers";
import { Container } from "@modules/pixi.js/lib";
import * as PIXI from "pixi.js";
import { Safe } from "../../../MyHelpers";
import { GetOrientation, Orientation } from "../../../FitScreen";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { JSONResource } from "../../../ResourceManager/JSONResource";
import { AwardJPShowElemntPIXAPPResponsive } from "./AwardJPShowPIXAPPResponsive";

export class AwardJPShowPIXIAPPResponsive extends AwardJPShowPIXAPP {
    private responsiveView: ResponsiveView;
    protected textureBackagroundContainer: PIXI.Sprite;

    constructor() {
        super();
        
    }

    public override PrepareResources(resourceManager: IWriteOnlyResourceManager): void {
        super.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        let bonusTitleSpineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineJson`));
        let bonusTitleSpine = await PIXI.Assets.load(bonusTitleSpineTextureJson.path);
         //this.AwardJPSPineJson = bonusTitleSpine.spineData;

        this.awardElements = new AwardJPShowElemntPIXAPPResponsive(bonusTitleSpine.spineData);
    }

    protected created: boolean = false;
    public override CreatePIXIAPP() {
        this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, {color: 0x220000, name: 'responsive-view'});       

        this.responsiveView.visible = false;
        this.textureBackagroundContainer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.textureBackagroundContainer.tint = "black";
        this.responsiveView.addChild(this.textureBackagroundContainer);
        
    
        this.awardElements.CreatePIXIAPP();
        const awardContainer = this.awardElements.ViewPIXIAPP();
        
        // if (GetOrientation() == Orientation.Portrait) {
        //     awardContainer.scale.set(0.8);
        //     awardContainer.y = 0;
        // } else {
        //     awardContainer.scale.set(1);
        //     awardContainer.y = 0;//window.innerHeight * 0.05;
        // }
        
        this.responsiveView.addChild(awardContainer);
        this.created = true;
        this.OnResize();
    }

    public override ViewPIXIAPP(): ResponsiveView {
        return this.responsiveView;
    }

    public OnResize() {
        
        if (!this.created) return;

        this.responsiveView?.setAvailableSize(window.innerWidth, window.innerHeight);
        this.textureBackagroundContainer.width = window.innerWidth;
        this.textureBackagroundContainer.height = window.innerHeight;

        // const awardContainer = this.awardElements?.ViewPIXIAPP();
        // if (awardContainer) {
        //     if (GetOrientation() == Orientation.Portrait) {
        //         awardContainer.scale.set(0.8);
        //         awardContainer.y = 0;
        //     } else {
        //         awardContainer.scale.set(1);
        //         awardContainer.y = window.innerHeight * 0.05;
        //     }
        // }

        this.awardElements?.RepositionDiamonds(window.innerWidth, window.innerHeight);
    }

    public override Destroy() {
        Safe(()=>{
            this.responsiveView.destroy({children : true});                       
        });
        Safe(()=>{
            this.awardElements?.Destroy();                       
        });

        this.created = false;
    }
}

